import { Inject, Injectable } from '@angular/core';
import { filter as rxFilter, map as rxMap, Observable } from 'rxjs';

import { DynamicFormsExtensionsService } from '@lockton-apps/dynamic-forms';
import { PROPOSAL_PARTNER_DATA } from '../../constants/proposal-partner-data';
import { ProposalProductDetailsComponent } from '@lockton-apps/shared/ui/proposal-product-details';
import { CastObservablePipe } from '@lockton-apps/shared/ui/pipes';
import {
  DocumentsService,
  SupportingDocumentsService,
} from '@lockton-apps/shared/data-access/documents';
import { FeedbackService } from '@lockton-apps/shared/ui/lui';

interface PartnerData {
  proposalId: string | undefined;
  createdDate: string;
  availableAddonCobs: number[];
  readonly: boolean;
}

@Injectable()
export class AccaOverDynamicFormsExtensionsService extends DynamicFormsExtensionsService {
  constructor(
    @Inject(PROPOSAL_PARTNER_DATA)
    protected readonly partnerData$: Observable<PartnerData>,
    castObservable: CastObservablePipe,
    documentsService: DocumentsService,
    supportingDocumentsService: SupportingDocumentsService,
    feedbackService: FeedbackService
  ) {
    super(
      castObservable,
      documentsService,
      supportingDocumentsService,
      feedbackService
    );
  }

  override extensions = [
    {
      id: 'productDetails',
      prop: 'component',
      value: ProposalProductDetailsComponent,
    },
    {
      id: 'productDetailsInputs',
      prop: 'inputs',
      value: '',
      mappedValue: () => ({
        cobs: this.partnerData$.pipe(
          rxFilter(Boolean),
          rxMap(({ availableAddonCobs }) => availableAddonCobs)
        ),
      }),
    },
  ];
}
